import React, { Component } from 'react';
import ViewHeader from '../../components/ViewHeader';
import MemberHeader from '../../components/MemberHeader';
import ModuleContainer from '../../components/ModuleContainer';
import { Col, FormGroup, FormLabel, Button, Card, FormControl } from 'react-bootstrap';
import { isStringEmptyOrNull, SideNotification } from '../../../utils/common';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CryptoJS from "crypto-js";
import { ENCRYPTION_KEY, REST_SERVICE_URL_ROOT } from '../../../config/settings';
import { isNullOrUndefined } from 'util';
import {
    NOTIF_ERROR, SUCCESS, ADTYPE_EVENT, DATE_FORMAT, RESERVATION_SUMMARY, EVENT_TITLE, EVENT_DESCRIPTION, TOTAL, RESERVE, NO, YES, SECONDARY, SUCCESS_BUTTON,
    EMPTY_STRING, NUMBER_OF_TICKETS, PRICE, TICKETS, SLASH_REGEX, SLASH
} from '../../../utils/constants';
import { reservationOperations, reservationSelectors } from './state';
import parse from 'html-react-parser';
import moment from 'moment';
import { MSG_CONFIRM_RESERVATION, CONFIRM_RESERVATION, INVALID_REQUEST_TO_WEBSITE, INVALID_REQUEST, INVALID_REQ, PAGE_LOADING } from '../../../utils/messages';
import ConfirmationModal from '../../components/ConfirmationModal';
import debounce from 'lodash.debounce';

class AdsReservation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: "Loading . . ",
            description: "Loading . . ",
            error: '',
            invalidRequest: false,
            purpose: '',
            imageHash: moment().format(DATE_FORMAT),
            adsId: '',
            userId: '',
            hasSubmit: false,
            showSaveModal: false,
            price: 0,
            tickets: 1,
            totalPrice: 0,
            ticketLimit: 0,
            isLoading: true
        }
        this.saveChanges = debounce(this.saveChanges.bind(this), 500);
    }

    componentDidMount() {
        let cryptUserId = this.props.match.params.userId.replace(SLASH_REGEX, SLASH);
        let cryptAdsId = this.props.match.params.adsId.replace(SLASH_REGEX, SLASH);
        let userId = CryptoJS.AES.decrypt(cryptUserId, ENCRYPTION_KEY).toString(CryptoJS.enc.Utf8);
        let adsId = CryptoJS.AES.decrypt(cryptAdsId, ENCRYPTION_KEY).toString(CryptoJS.enc.Utf8);

        try {
            if (isNullOrUndefined(cryptUserId) || isNullOrUndefined(cryptAdsId)
                || isStringEmptyOrNull(userId) || isStringEmptyOrNull(adsId)) {
                SideNotification(NOTIF_ERROR, INVALID_REQUEST_TO_WEBSITE);
                this.setState({ isLoading: false, invalidRequest: true })
            } else {
                this.props.getPublicAdsById(adsId)
                    .then(result => {
                        if (SUCCESS === result.status && ADTYPE_EVENT === result.data.adTypeId) {
                            this.setState({
                                title: result.data.adsTitle,
                                description: result.data.adsDescription,
                                adsId: adsId,
                                userId: userId,
                                price: result.data.adsPrice,
                                ticketLimit: result.data.redemptionLimit,
                                totalPrice: result.data.adsPrice * this.state.tickets,
                                isLoading: false
                            })
                        } else {
                            this.setState({ invalidRequest: true, isLoading: false })
                            SideNotification(NOTIF_ERROR, INVALID_REQUEST_TO_WEBSITE);
                        }
                    }).catch(() => {
                        this.setState({ invalidRequest: true, isLoading: false })
                    });
            }
        } catch{
            SideNotification(NOTIF_ERROR, INVALID_REQUEST);
            this.setState({ invalidRequest: true, isLoading: false })
        }
    }

    toggleSave = () => {
        this.setState(prevState => ({ showSaveModal: !prevState.showSaveModal }));
    }

    handleSubmit = () => {
        let validate = reservationSelectors.validateDonationForm(this.state);
        this.setState({ hasSubmit: true })
        if (isNullOrUndefined(validate.tickets)) {
            this.toggleSave();
        } else {
            this.setState({ error: validate.tickets })
        }
    }


    saveChanges = () => {
        let details = {
            adsId: this.state.adsId,
            userId: this.state.userId,
            totalPrice: this.state.totalPrice,
            tickets: this.state.tickets
        }

        this.props.insertReservation(details)
            .then(result => {
                if (undefined !== result) {
                    if (SUCCESS === result.status) {
                        this.props.history.push("/reservation/response")
                    } else {
                        SideNotification(NOTIF_ERROR, result.message)
                    }
                }
            })
    }

    handleInputChange = (event) => {
        if (event.target.value % 1 === 0 && !(event.target.value.toString()).includes(".")) {
            let totalPrice = event.target.value * this.state.price
            this.setState({ tickets: event.target.value, totalPrice: totalPrice }, () => {
                let validate = reservationSelectors.validateDonationForm(this.state);
                if (isNullOrUndefined(validate.tickets)) {
                    this.setState({ error: '' })
                } else {
                    this.setState({ error: validate.tickets })
                }

            })
        }
    }

    render() {
        if (this.state.isLoading) {
            return (
                <div>
                    <MemberHeader />
                    <ModuleContainer>
                        <h2>{PAGE_LOADING}</h2>
                    </ModuleContainer>
                </div>
            )
        } else if (EMPTY_STRING === this.state.userId) {
            return (
                <div>
                    <MemberHeader />
                    <ModuleContainer>
                        <h2>{INVALID_REQ}</h2>
                    </ModuleContainer>
                </div>
            )
        } else {
            return (
                <div>
                    <MemberHeader />
                    <ModuleContainer style={{ borderColor: "#fff" }}>
                        <ViewHeader title={RESERVATION_SUMMARY} titleClass="text-center" />
                        <Col md={{ span: 10, offset: 1 }} xl={{ span: 6, offset: 3 }} xs={12} className={"reserve-card"}>
                            <Card>
                                <center style={{ padding: 30 }}>
                                    <FormGroup className={"form-input"}>
                                        <FormLabel className="text-blue">{EVENT_TITLE}</FormLabel >
                                        <h3>{this.state.title}</h3>
                                    </FormGroup>

                                    <img
                                        alt="donation"
                                        src={`${REST_SERVICE_URL_ROOT}/ads/image/${this.state.adsId}?${this.state.imageHash}`}
                                        style={{ width: 250, height: 250, marginTop: 20, marginBottom: 20 }}
                                    />

                                    <FormGroup className={"form-input"}>
                                        <FormLabel className="text-blue">{EVENT_DESCRIPTION}</FormLabel >
                                        <p>{parse(this.state.description)}</p>
                                    </FormGroup>
                                </center>
                                <hr />
                                <center>
                                    <FormGroup controlId="tickets" style={{ width: '100%' }}>
                                        <FormLabel className="text-blue">{PRICE}</FormLabel>
                                        <h4 style={{ paddingLeft: 8, marginBottom: 18 }}><span>&#8369;</span>{parseFloat(this.state.price).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</h4 >
                                        <FormLabel className="text-blue">{NUMBER_OF_TICKETS}</FormLabel>
                                        <FormControl
                                            size="lg"
                                            type="number"
                                            autoComplete="off"
                                            maxLength={10}
                                            step={1}
                                            className="tickets"
                                            value={this.state.tickets}
                                            onChange={event => { this.handleInputChange(event) }}
                                        />

                                        {isStringEmptyOrNull(this.state.error) ? EMPTY_STRING : <p className="formik-error">{this.state.error}</p>}
                                        <hr className="reserve-hr" /><br /><br />
                                        <div>
                                            <b className="totalPrice">{TOTAL}
                                                <span>&#8369;</span> {TICKETS < this.state.tickets ? parseFloat(this.state.totalPrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
                                            </b>
                                        </div>
                                        <div className="reserve-div">
                                            <Button type="button" className="reserve-button" disabled={TICKETS >= this.state.tickets} onClick={() => this.handleSubmit()}>
                                                {RESERVE}
                                            </Button>
                                        </div>
                                    </FormGroup>

                                </center>

                            </Card>
                        </Col>
                    </ModuleContainer>

                    <ConfirmationModal
                        show={this.state.showSaveModal}
                        toggleModal={this.toggleSave}
                        title={CONFIRM_RESERVATION}
                        message={MSG_CONFIRM_RESERVATION}
                        modalButtons={[
                            { label: NO, onClick: this.toggleSave, variant: SECONDARY },
                            { label: YES, onClick: this.saveChanges, variant: SUCCESS_BUTTON }
                        ]}
                    />
                </div>
            );
        }
    }
}


const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        getPublicAdsById: reservationOperations.getPublicAdsById,
        insertReservation: reservationOperations.insertReservation
    },
    dispatch
);

export default connect(null, mapDispatchToProps)(AdsReservation);